import styled, { css } from 'styled-components';
import Tokens from '@nokia-csf-uxr/freeform-design-tokens';
import { BORDER_BOX } from 'common';

export default {
  ButtonsRow: styled.div`
    ${BORDER_BOX}
    ${props => css`direction: ${(props.RTL || props.$rtl || props.rtl) ? 'rtl' : 'ltr'};`}
    flex: 0;
    justify-self: end;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
    padding: ${Tokens.SPACING.SPACING_16};
    > *:not(:first-child) {
      margin-left: ${props => (props.RTL || props.$rtl || props.rtl) ? Tokens.SPACING.SPACING_0 : Tokens.SPACING.SPACING_8};
      margin-right: ${props => (props.RTL || props.$rtl || props.rtl) ? Tokens.SPACING.SPACING_8 : Tokens.SPACING.SPACING_0};
    }
  `,
};
